// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Box,
  Divider,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useResponsive from "../../../hooks/useResponsive";
// components
import DIOText from '../../../components/DIOText';

const BlueText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightBold,
  };
});


export default function NoDeveloperDialog({ open, closeDialog, skip }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="sm">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h5" sx={{ wordBreak: "keep-all", mb: { xs: 2, sm: 3 } }}>
          사내 개발자나 외주사가 없다면 일단 건너뛰세요.
        </Typography>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            backgroundColor: "grey.200",
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            🧑🏻‍💻 회사에 개발자가 있거나, 외주사에 맡겼던 프로젝트인가요?
          </Typography>
          <Typography variant="body1">
            개발자나 외주사에게 <BlueText>'개발 스택'</BlueText>을 알려달라고 하시면 됩니다.
          </Typography>

          <Divider sx={{ my: { xs: 2, sm: 3 } }} />

          <Typography variant="subtitle1" gutterBottom>
            🧐 새로 개발하는 상황인가요?
          </Typography>
          <Typography variant="body1">
            이 단계는 일단 건너뛰고, 나머지 내용 작성을 완료하면 <DIOText /> 기술 지원팀에서 전화드리겠습니다.
          </Typography>

        </Box>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack
          display="flex"
          justifyContent="flex-end"
          direction={{ xs: "column-reverse", sm: "row" }}
          sx={{ width: 1 }}
          spacing={2}
        >
          <Button
            onClick={closeDialog}
            size="large"
            sx={{ px: 5 }}
          >
            닫기
          </Button>
          <Button
            variant="contained"
            onClick={skip}
            size="large"
            sx={{ px: 5 }}
          >
            이 단계 건너뛰기
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
